var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "guide-availability" },
    [
      _c("div", { staticClass: "level guide-availability__toolbar" }, [
        _c("div", { staticClass: "level-left" }, [
          _c("div", { staticClass: "level-item guide-availability__nav" }, [
            _c(
              "button",
              {
                staticClass: "button is-small",
                attrs: { type: "button", title: "Zurück" },
                on: {
                  click: function ($event) {
                    return _vm.step(-1)
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("chevron_left"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("h2", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button is-small",
                attrs: { type: "button", title: "Weiter" },
                on: {
                  click: function ($event) {
                    return _vm.step(1)
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("chevron_right"),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.month !== null
              ? _c(
                  "button",
                  {
                    staticClass: "button is-small",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.month = null
                      },
                    },
                  },
                  [_vm._v("Ganzes Jahr")]
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "level-right" }, [
          _c(
            "div",
            { staticClass: "level-item guide-availability__legend" },
            [
              _vm._l(_vm.labels, function (label, key) {
                return _c("span", { key: key }, [
                  _c("i", { staticClass: "swatch", class: "is-" + key }),
                  _vm._v(_vm._s(label)),
                ])
              }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.isLoading && !_vm.loadedYear
        ? _c("loading")
        : _vm.month === null
        ? _c(
            "div",
            {
              staticClass: "guide-availability__year",
              on: { pointerdown: _vm.onPointerDown },
            },
            _vm._l(_vm.monthNames, function (name, m) {
              return _c(
                "div",
                { key: m, staticClass: "guide-availability__month" },
                [
                  _c("h3", [
                    _c(
                      "button",
                      {
                        attrs: { type: "button", title: name + " öffnen" },
                        on: {
                          click: function ($event) {
                            _vm.month = m
                          },
                        },
                      },
                      [_vm._v(_vm._s(name))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "guide-availability__grid" },
                    [
                      _vm._l(_vm.weekdays, function (wd) {
                        return _c(
                          "div",
                          { key: wd, staticClass: "ga-weekday" },
                          [_vm._v(_vm._s(wd[0]))]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.leadingBlanks(m), function (n) {
                        return _c("div", {
                          key: "b" + n,
                          staticClass: "ga-day is-blank",
                        })
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.daysOf(m), function (day) {
                        return _c(
                          "div",
                          {
                            key: day.key,
                            staticClass: "ga-day",
                            class: _vm.dayClasses(day),
                            attrs: {
                              "data-key": day.key,
                              title: _vm.dayTitle(day),
                            },
                          },
                          [_vm._v(_vm._s(day.d))]
                        )
                      }),
                    ],
                    2
                  ),
                ]
              )
            }),
            0
          )
        : _c(
            "div",
            {
              staticClass: "guide-availability__zoom",
              on: { pointerdown: _vm.onPointerDown },
            },
            [
              _c(
                "div",
                { staticClass: "guide-availability__grid" },
                [
                  _vm._l(_vm.weekdays, function (wd) {
                    return _c("div", { key: wd, staticClass: "ga-weekday" }, [
                      _vm._v(_vm._s(wd)),
                    ])
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.leadingBlanks(_vm.month), function (n) {
                    return _c("div", {
                      key: "b" + n,
                      staticClass: "ga-day is-blank",
                    })
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.daysOf(_vm.month), function (day) {
                    return _c(
                      "div",
                      {
                        key: day.key,
                        staticClass: "ga-day",
                        class: _vm.dayClasses(day),
                        attrs: {
                          "data-key": day.key,
                          title: _vm.dayTitle(day),
                        },
                      },
                      [
                        _c("span", { staticClass: "ga-day__number" }, [
                          _vm._v(_vm._s(day.d)),
                        ]),
                        _vm._v(" "),
                        _vm.periodByDay[day.key] &&
                        _vm.periodByDay[day.key].note
                          ? _c("span", { staticClass: "ga-day__note" }, [
                              _vm._v(_vm._s(_vm.periodByDay[day.key].note)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          _vm.groupsByDay[day.key] || [],
                          function (group) {
                            return _c(
                              "a",
                              {
                                key: group.orderId,
                                staticClass: "ga-day__group",
                                attrs: {
                                  href: "/orders/" + group.orderId,
                                  target: "_blank",
                                },
                                on: {
                                  pointerdown: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(group.orderId) +
                                    " " +
                                    _vm._s(group.name)
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    )
                  }),
                ],
                2
              ),
            ]
          ),
      _vm._v(" "),
      _vm.selection
        ? _c(
            "div",
            { staticClass: "guide-availability__entry" },
            [
              _c("strong", [_vm._v(_vm._s(_vm.selectionLabel))]),
              _vm._v(" "),
              _vm._l(_vm.labels, function (label, key, index) {
                return _c(
                  "button",
                  {
                    key: key,
                    staticClass: "button is-status",
                    class: "is-" + key,
                    attrs: { type: "button", disabled: _vm.isSaving },
                    on: {
                      click: function ($event) {
                        return _vm.save(key)
                      },
                    },
                  },
                  [
                    _vm._v(_vm._s(label) + " "),
                    _c("kbd", [_vm._v(_vm._s(index + 1))]),
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button",
                  attrs: { type: "button", disabled: _vm.isSaving },
                  on: {
                    click: function ($event) {
                      return _vm.save(null)
                    },
                  },
                },
                [_vm._v("löschen")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.note,
                    expression: "note",
                  },
                ],
                ref: "note",
                staticClass: "input",
                attrs: {
                  type: "text",
                  maxlength: "255",
                  placeholder: "Notiz, optional (z. B. „Optionen bei anderen“)",
                },
                domProps: { value: _vm.note },
                on: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return $event.target.blur()
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.note = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button is-text",
                  attrs: { type: "button", title: "Auswahl aufheben (Esc)" },
                  on: { click: _vm.clearSelection },
                },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("i", { staticClass: "swatch is-none" }),
      _vm._v("keine Angabe"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("i", { staticClass: "swatch is-group" }),
      _vm._v("unsere Gruppe"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }